import { query_post_sale_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model2/mjstore/mjstore-postsale-config';

import { reactive } from 'vue';

const None = null;

const search_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const update_model_config_options = {};

const titleList = {
  title: '撤单管理',
  addModalTitle: '新建撤单',
  updateTitle: '修改撤单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '耗单日期',
    width: 150,
    dataIndex: 'date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '耗单号',
    width: 180,
    dataIndex: 'order_used_record__order_code',
    checked: true,
  },
  {
    title: '项目名称',
    width: 180,
    dataIndex: 'order_used_record__project__name',
    checked: true,
  },
  {
    title: '项目次数',
    width: 80,
    dataIndex: 'order_used_record__num',
    checked: true,
  },

  {
    title: '销售执行门店',
    width: 120,
    dataIndex: 'order_used_record__shop__name',
    checked: true,
  },
  {
    title: '销售执行人',
    width: 120,
    dataIndex: 'order_used_record__staff__name',
    checked: true,
  },
  {
    title: '使用情况',
    width: 600,
    dataIndex: 'note',
    checked: true,
  },
  {
    title: '跟进执行门店',
    width: 120,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '跟进执行人',
    width: 100,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '最近跟进日期',
    width: 150,
    dataIndex: 'last_date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 80,
    checked: true,
    slots: { customRender: 'action' },
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_post_sale_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
